<template>
  <FormGroup :starts-enabled="!!initialValue || null" :scope="scope">
    <template v-slot="{ inputName, inputId, error }">
      <input
        v-model="currentValue"
        type="datetime-local"
        :id="inputId"
        class="form-control"
        :class="{
            'input-changed': wasChanged,
            'is-invalid': error,
          }"
        :name="inputName"
        :placeholder="placeholder"
      >
    </template>
  </FormGroup>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";
import FormGroup from "@/components/backend/candidacy/form_builder/form_items/shared/FormGroup.vue";

export default defineComponent({
  name: "DateTimeField",
  components: { FormGroup },
  props: {
    initialValue: {
      type: String,
      required: false
    },
    scope: {
      type: Array as PropType<string[]>,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    }
  },
  data: ({ initialValue }) => ({
    currentValue: initialValue,
  }),
  computed: {
    wasChanged() {
      return this.initialValue !== this.currentValue;
    }
  },
});
</script>
